<template>
    <v-simple-table
        v-if="handlingFee > 0 || fetchHandlingFeePerItemTotal > 0"
        dense
        class="totals-table--bordered"
    >
        <thead>
            <tr>
                <th class="totals-th--bordered">
                    <TranslatableStringComponent
                        :tstring="{ string: 'handlingFee' }"
                    />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="totals-td--bordered">
                    <div class="mb-4">
                        <span>{{ dollars(handlingFeeTotal) }}</span>
                    </div>
                    <p style="font-size: 12px">
                        <fa
                            :icon="['fal', 'info-circle']"
                            v-bind="attrs"
                            class="fa-lg mr-2"
                            style="color: #0063a6"
                        />

                        <span>
                            <TranslatableStringComponent
                                :tstring="{
                                    string: `${handlingFeeMessage}`,
                                }"
                            />
                        </span>
                    </p>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'HandlingFeeSection',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return { attrs: null }
    },
    computed: {
        ...mapGetters({
            handlingFee: 'cart/fetchHandlingFee',
            fetchHandlingFeePerItemTotal: 'cart/fetchHandlingFeePerItemTotal',
            fetchCartSubtotal: 'cart/fetchCartSubtotal',
            fetchCartSubtotalForNormalProducts:
                'cart/fetchCartSubtotalForNormalProducts',
            isInternationalShipping: 'checkout/isInternationalShipping',
        }),
        handlingFeeTotal() {
            return this.handlingFee + this.fetchHandlingFeePerItemTotal
        },
        handlingFeeMessage() {
            if (this.handlingFee && this.fetchHandlingFeePerItemTotal) {
                return 'checkoutNoticeHandlingFeeNonSPQAndOrder'
            } else if (this.handlingFee && !this.fetchHandlingFeePerItemTotal) {
                if (this.isInternationalShipping) {
                    return 'checkoutNoticeHandlingFeeForInxShipping'
                } else if (
                    this.fetchCartSubtotal ===
                    this.fetchCartSubtotalForNormalProducts
                ) {
                    return 'checkoutNoticeHandlingFee'
                } else {
                    return 'checkoutNoticeHandlingFeePlusOversized'
                }
            } else if (!this.handlingFee && this.fetchHandlingFeePerItemTotal) {
                return 'checkoutNoticeHandlingFeeNonSPQOnly'
            } else {
                return ''
            }
        },
    },
}
</script>

<style></style>
